import React, { FC } from 'react'
import { RootContainer } from '@root/RootContainer'

const Page404: FC = () => {
  return (
    <RootContainer>
      <h1>🐺Ошибка 404 Страница не найдена</h1>
    </RootContainer>
  )
}

export default Page404
